//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'

import MetroLinesData from '@/data/metro_lines'

export default {
    data () {
        return {
            type: 'zone',
            tabs: [
                {
                    text: '城区',
                    value: 'zone'
                },
                {
                    text: '地铁',
                    value: 'metro'
                }
            ],
            selected_zone: '',
            zones: [],
            sections: [],
            metros: []
        }
    },
    computed: {
        selected_all_section () {
            return this.sections.every(({ selected }) => {
                return selected
            }) || this.sections.every(({ selected }) => {
                return !selected
            })
        },
        zone_opts_classname () {
            return this.sections.length > 0 ? 'opts1' : 'opts2'
        }
    },
    watch: {
        zone_ids (zone_ids, old) {
            if (zone_ids != old) {
                this.selected_zone = zone_ids
                if (zone_ids) {
                    let selected_sections = []
                    this.zones.some(({id, sections}) => {
                        if (id === zone_ids) {
                            selected_sections = sections
                        }
                    })
                    this.sections = selected_sections.map((item) => {
                        return {
                            ...item,
                            selected: false
                        }
                    })
                }
            }
        },
        zone_section_ids (zone_section_ids, old) {
            if (zone_section_ids != old) {
                if (zone_section_ids) {
                    this.sections.some((section, i) => {
                        if (section.id === Number(zone_section_ids)) {
                            this.$set(this.sections, i, {
                                ...section,
                                selected: true
                            })
                            return true
                        }
                    })
                } else {
                    this.selectAllSection()
                }
            }
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        changeType (type) {
            this.type = type
        },
        async getData () {
            const { level1, level2, level3, others } = await Service.getZones()
            this.zones = level1.concat(level2).concat(level3).concat(others)
            const lines = await MetroLinesData.getMetroLines()
            this.metros = lines.map((line) => {
                return {
                    name: line,
                    value: parseInt(line),
                    selected: false
                }
            })
        },
        selectAll () {
            this.selected_zone = ''
            this.selectAllSection()
        },
        onSelect (e) {
            const { index } = e.currentTarget.dataset
            const { id, sections } = this.zones[index]
            this.selected_zone = id
            this.sections = sections.map((item) => {
                return {
                    ...item,
                    selected: false
                }
            })
        },
        onSelectSection (e) {
            const { index } = e.currentTarget.dataset
            const item = this.sections[index]
            this.$set(this.sections, index, {
                ...item,
                selected: !item.selected
            })
        },
        selectAllSection () {
            this.sections.forEach((item, index) => {
                this.$set(this.sections, index, {
                    ...item,
                    selected: false
                })
            })
        },
        onSelectMetro (selected_index) {
            const metro = this.metros[selected_index]
            this.$set(this.metros, selected_index, {
                ...metro,
                selected: !metro.selected
            })
        },
        reset () {
            this.selected_zone = ''
            this.sections.forEach((item, i) => {
                this.$set(this.sections, i, {
                    ...item,
                    selected: false
                })
            })
            this.metros.forEach((item, i) => {
                this.$set(this.metros, i, {
                    ...item,
                    selected: false
                })
            })
        },
        confirm () {
            const selected_section = this.sections.filter(({ selected }) => selected).map(({ id }) => id)
            let selected_tx
            if (this.selected_zone) {
                this.zones.some(({ id, name }) => {
                    if (id === this.selected_zone) {
                        selected_tx = name
                        return true
                    }
                })
                this.sections.forEach(({ name, selected }) => {
                    if (selected) {
                        selected_tx += `,${name}`
                    }
                })
            }
            this.$emit('changeZone', this.selected_zone, selected_tx || '不限', selected_section.join(','))
            this.$emit('changeMetro',this.metros
                .filter(({ selected, value }) => selected && value)
                .map(({ value }) => `${value}号线`)
                .join(',')
            )
        }
    },
    props: {
        zone_ids: [String, Number],
        zone_section_ids: [String, Number],
        show: {
            type: Boolean
        }
    }
}
